(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-schoko-product-image]').forEach((container) => {
      if (container.dataset.schokoBound) return;
      container.dataset.schokoBound = 'true';
      const image = container.querySelector('[type="gp-feature-image-only"]');
      if (!image) return;
      image.setAttribute('role', 'link');
      image.tabIndex = 0;
      const navigate = () => { window.location.href = container.dataset.productUrl; };
      image.addEventListener('click', navigate);
      image.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') navigate();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
